/* eslint-disable @typescript-eslint/no-explicit-any */
export const INVOKE_CHANGE_SERVER = "changeServer";
export const INVOKE_CLEAR_STORAGE = "clearStorage";
export const INVOKE_SHOW_NOTIFICATIONS = "showNotifications";
export const INVOKE_LOG_OUT = "logOutUser";
export const INVOKE_ALREADY_GUIDED = "alreadyGuided";
export const PUSH_WEB_VIEW_URL = "pushWebViewUrl";
export const RESOLVE_NOTIFICATION = "resolveTemplateNotification";
export const DOWNLOAD_FILE_NATIVE = "downloadFileNative";
export const OPEN_FILE_NATIVE = "openFileNative";
export const RESOLVE_SYSTEM_NOTIFICATION = "resolveSystemNotification";
export const REDIRECT_TO_NATIVE_LOGIN = "redirectToNativeLogin";
export const REFETCH_NOTIFICATIONS = "refetchNotifications";
export const EXPORT_TABLE = "exportFileNative";

export type PushWebViewUrlType = typeof PUSH_WEB_VIEW_URL;
export type ResolveNotificationType = typeof RESOLVE_NOTIFICATION;

export type WebViewDispatchTypes = PushWebViewUrlType | ResolveNotificationType;

export const isNativeApp = () => (window as any).isNativeApp === true;

export const invokeRNMessage = (type: string, payload: any) => {
  if (isNativeApp()) {
    const data = {
      type,
      payload,
    };
    (window as any).ReactNativeWebView.postMessage(JSON.stringify(data));
  }
};

export const refetchNotificationsRN = () =>
  invokeRNMessage(REFETCH_NOTIFICATIONS, true);

export const resolveSystemNotificationRN = (dataSourceId: number) =>
  invokeRNMessage(RESOLVE_SYSTEM_NOTIFICATION, { dataSourceId });

type ExportTablePayload = {
  fileName: string;
  fileExtension: string;
  base64Data: string;
};

export const exportTableDataRN = (payload: ExportTablePayload) =>
  invokeRNMessage(EXPORT_TABLE, payload);
